import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FailedLoginInfo } from '@olv/ui-shared/services/reports.service';

@Component({
  selector: 'app-failed-login-drawer',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './failed-login-drawer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './failed-login-drawer.component.scss',
})
export class FailedLoginDrawerComponent {
  @Input({ required: true }) failedLoginInfo!: FailedLoginInfo;
  @Input() activityType = '';
  @Input() userName = '';
  @Input() entityNameValue = '';
  @Input() activityDate = '';

  @Output() closed = new EventEmitter<void>();

  onClose(): void {
    this.closed.emit();
  }
}
